<ng-template #content_receipt_options_content let-offcanvas>
    
</ng-template>